import axios from "axios";
import { getBaseUrl } from "./config";

const apiClient = axios.create({
  baseURL: getBaseUrl(), // Replace with your base API URL
  timeout: 30000, // Optional: Set a timeout for requests
});

// Function to handle API requests
const request = async (url, options) => {
  const {
    method = "GET",
    body,
    params = null,
    headers = null,
    auth = false,
    query = {},
  } = options;
  
  try {
    const apiHeaders = {
      "Content-Type": "application/json",
      ...headers, // Allow overriding default headers
    };

    if (auth) {
      const token = localStorage.getItem("token");
      apiHeaders.Authorization = `Bearer ${token}`;
    }

    if (params) {
      url = `${url}/${params}`;
    }
    const response = await apiClient({
      url,
      method,
      data: body, // For POST, PUT, etc.
      params: query, // For query parameters in GET requests
      headers: apiHeaders,
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      // Handle session expiration
      if (error.response.status === 401) {
        console.log("Session expired - redirecting to login");
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }
      // Handle server-side errors
      console.error("API Error:", error.response.data);
      throw error.response.data;
    } else if (error.request) {
      // Handle network errors
      console.error("Network Error:", error.request);
      throw { message: "Network Error", error };
    } else {
      // Handle unexpected errors
      console.error("Unexpected Error:", error.message);
      throw { message: error.message };
    }
  }
};

export default request;